import Axios from "axios";
import { getBaseURL } from "./baseURL.js";

//page the reviewer should land on when opening the manual
const START_PAGE = 12;

//matches the literal route on DocumentationController - keeping the file name in the
//url is what gives the browser tab and the viewer's save button a sensible name
const DOCUMENT_PATH = "documentation/Document_Review_Process.pdf";

/**
 * Builds a url for the Document Review Process manual that a browser can navigate
 * to directly.
 *
 * A navigation cannot carry a bearer token, so we first ask the API - with the
 * token - for a short lived key, and hand that over on the query string instead.
 */
export const getInstructionsUrl = async (idToken) => {
  const response = await Axios.get(
    `${getBaseURL()}/documentation/reviewprocess/token`,
    { headers: { Authorization: "Bearer " + idToken } }
  );

  const token = encodeURIComponent(response.data.token);

  return `${getBaseURL()}/${DOCUMENT_PATH}?token=${token}#page=${START_PAGE}`;
};

/**
 * Opens the manual in its own tab. Must be called from a click handler: the tab
 * is opened synchronously with a placeholder so the popup blocker sees the user
 * gesture, then pointed at the pdf once we have a token.
 *
 * Returns false if the popup was blocked, so the caller can tell the user.
 */
export const openInstructionsInNewTab = async (idToken) => {
  const tab = window.open("", "_blank");

  if (tab) {
    tab.document.write("Loading the Document Review Process manual...");
  }

  try {
    const url = await getInstructionsUrl(idToken);

    if (!tab) return false;

    tab.location = url;
    return true;
  } catch (error) {
    if (tab) tab.close();
    throw error;
  }
};
